
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/privacy",
      function () {
        return require("private-next-pages/fr/privacy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/privacy"])
      });
    }
  